<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div 
        v-if="computedValue.items && computedValue.items.length" 
        class="d-flex justify-end mb-2 px-2"
      >
        <v-btn
          class="btn-delete rounded-lg"
          outlined
          small
          :loading="isDeletingAll"
          @click="deleteAllCategories"
        >
          <v-icon right class="px-2">mdi-delete-sweep</v-icon>
          {{ $t("delete_all") || "حذف همه دسته‌ها" }}
        </v-btn>
      </div>

      <v-card flat>
        <v-expansion-panels class="pa-2">
          <v-expansion-panel
            v-for="(category, index) in computedValue.items"
            :key="index"
            class="mt-2 rounded-lg"
            @click="openDialog(index)"
          >
            <v-expansion-panel-header hide-actions>
              <v-btn
                :disabled="index === 0"
                class="me-2"
                icon
                max-width="32"
                @click.stop="moveUp(index)"
              >
                <v-icon>mdi-chevron-up</v-icon>
              </v-btn>

              <div>
                <img
                  :src="
                    category.photoBackground ||
                    category.icon ||
                    category.picture
                  "
                  alt=""
                  class="rounded-lg me-2"
                  style="object-fit: contain"
                  width="48px"
                />

                <v-btn class="d-none d-md-inline-block" outlined>
                  {{ $t("edit_category") }}
                  {{ category.name || category.title }}
                </v-btn>

                <div class="d-md-none pt-2">
                  {{ category.name || category.title }}
                </div>
              </div>
              <v-spacer />
              <v-btn
                :disabled="index === computedValue.items.length - 1"
                icon
                max-width="32"
                @click.stop="moveDown(index)"
              >
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>

              <v-btn icon max-width="36" @click.stop="deleteCat(index)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>

              <!-- <v-btn
                icon
                max-width="36"
                :title="$t('copy_category')"
                @click.stop="copyCat(category, index)"
              >
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
              <help-info
                v-if="index === 0"
                left
                :element-name="`${serviceName}-${componentName}-product-index`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :title="$t('copy_category')"
              /> -->
            </v-expansion-panel-header>
          </v-expansion-panel>
        </v-expansion-panels>
        <product-management :id="qr_id" @fetch="fetch" />
        <category-picker v-model="showAddCat" @submit="submitNewCategories" />
        <product-picker
          v-if="!!computedCategory"
          ref="productPicker"
          v-model="pickProducts"
          :category-id="computedCategoryPickerId"
          :is-model-list="isModelList"
          :selected-cat="computedCategory"
          @add="saveNewProduct"
          @addBulk="addBulkProduct"
          @remove="
            deleteProduct(
              computedCategory.products.findIndex(
                (product) => product.temp_id === $event,
              ),
              true,
            )
          "
          @save="saveProducts"
          @saveBulk="saveBulkProduct"
        />

        <add-custom-category
          v-model="showAddSubCat"
          @submit="submitNewCategories($event, true)"
        />

        <custom-popup
          v-model="dialog"
          :close-on-confirm="false"
          :cons="cons"
          :hide-confirm="productDetails && !isModelList"
          hide-close
          max-height="80vh"
          max-width="1024"
          :persistent="true"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-add-edit-products`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('add_edit_products')"
            />
          </template>
          <v-card
            :loading="loading"
            class="dialog-content"
            flat
            min-height="50vh"
          >
            <transition mode="out-in" name="slide-x-transition">
              <div v-if="!productDetails" key="products">
                <v-tabs v-model="tabs">
                  <v-tab v-for="(cat, i) in computedValue.items" :key="i">
                    <v-avatar
                      v-if="!!cat.icon || !!cat.picture"
                      class="ml-2"
                      size="32"
                    >
                      <v-img :src="cat.icon || cat.picture" contain />
                    </v-avatar>
                    <v-icon v-else right>mdi-archive-plus</v-icon>

                    {{ cat.name || cat.title }}
                  </v-tab>
                </v-tabs>

                <div class="d-flex align-center" style="min-height: 48px">
                  <div class="rowinfo">
                    <v-btn
                      class="mx-2 contentinfo"
                      color="success"
                      icon
                      outlined
                      small
                      :title="$t('addSubCategory')"
                      @click="showAddSubCat = true"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-computedsubCategory-name`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('addSubCategory')"
                    />
                  </div>
                  <v-tabs
                    v-if="
                      !!computedValue &&
                      !!computedValue.items &&
                      !!computedValue.items[tabs] &&
                      !!computedValue.items[tabs].children &&
                      !!computedValue.items[tabs].children.length
                    "
                    v-model="subTabs"
                    color="purple"
                    style="max-width: calc(100% - 48px)"
                  >
                    <v-tab
                      v-for="(sub, i) in computedValue.items[tabs].children"
                      :key="i"
                      class="px-2"
                    >
                      <v-avatar
                        v-if="!!sub.icon || !!sub.picture"
                        class="ml-2"
                        size="32"
                      >
                        <v-img :src="sub.icon || sub.picture" contain />
                      </v-avatar>
                      <v-icon v-else right>mdi-archive-plus</v-icon>

                      {{ sub.name || sub.title }}

                      <v-btn
                        class="mr-1"
                        icon
                        small
                        @click.stop="deleteSubCat(i)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-tab>
                  </v-tabs>
                </div>

                <v-tabs-items v-if="hasComputedCategory" v-model="tabs">
                  <v-tab-item
                    v-for="(category, index) in computedValue.items"
                    :key="index"
                  >
                    <v-card
                      v-if="!!computedCategory"
                      class="pa-2 rounded-lg"
                      outlined
                    >
                      <custom-tabs v-model="catTabs" :tab-items="tabItems" grow>
                        <template v-slot:helpinfo="{ tab }">
                          <help-info
                            v-if="tab && tab.value && tab.text"
                            :element-name="`${serviceName}-${componentName}-data-${tab.value}`"
                            :service-name="serviceName"
                            :help-data="helpData"
                            class="buttoninfo"
                            :label="`${tab.text}`"
                          />
                        </template>
                        <template v-slot:staticItems>
                          <v-tab-item>
                            <v-row class="py-2" no-gutters>
                              <v-col class="pa-2 text-left" cols="12">
                                <v-divider class="mt-0" />
                                <div
                                  class="rowinfo mx-2 mb-2 mb-md-0"
                                  style="align-items: center !important"
                                >
                                  <v-btn
                                    :loading="saveProductsLoading || loading"
                                    color="info"
                                    outlined
                                    small
                                    @click="pickProducts = true"
                                  >
                                    <v-icon>mdi-plus</v-icon>
                                    {{ $t("saveProducts") }}
                                  </v-btn>
                                  <help-info
                                    @update:helpData="
                                      (newData) => updateData(newData)
                                    "
                                    :element-name="`${serviceName}-${componentName}-saveProductsLoading-name`"
                                    :service-name="serviceName"
                                    :help-data="helpData"
                                    class="buttoninfo"
                                    :label="$t('saveProducts')"
                                  />
                                  <v-btn
                                    v-if="
                                      !computedCategory.ids_list ||
                                      !computedCategory.ids_list.length ||
                                      !isModelList
                                    "
                                    color="success"
                                    outlined
                                    small
                                    @click="addProduct"
                                  >
                                    <v-icon>mdi-plus</v-icon>
                                    {{ $t("addProduct") }}
                                  </v-btn>
                                  <help-info
                                    v-if="
                                      !computedCategory.ids_list ||
                                      !computedCategory.ids_list.length ||
                                      !isModelList
                                    "
                                    @update:helpData="
                                      (newData) => updateData(newData)
                                    "
                                    :element-name="`${serviceName}-${componentName}-saveProductsLoading-name`"
                                    :service-name="serviceName"
                                    :help-data="helpData"
                                    class="buttoninfo"
                                    :label="$t('addProduct')"
                                  />
                                </div>
                              </v-col>

                              <v-col
                                v-if="
                                  !!computedCategory.ids_list &&
                                  !!computedCategory.ids_list.length
                                "
                                class="pa-2"
                              >
                                <v-chip
                                  v-for="(chip, j) in computedCategory.ids_list"
                                  :key="j"
                                  class="me-2 mb-2"
                                  close
                                  small
                                  @click:close="closeClicked(j)"
                                >
                                  {{ chip }}
                                </v-chip>
                              </v-col>

                              <!--                          <template v-else-if="saveProductsLoading">-->
                              <!--                            <v-col class="pa-4 text-center" cols="12">-->
                              <!--                              <v-progress-circular indeterminate size="50" width="5"/>-->
                              <!--                            </v-col>-->
                              <!--                          </template>-->

                              <template v-else>
                                <v-col
                                  v-for="(
                                    product, index1
                                  ) in computedCategory.products"
                                  :key="index1"
                                  class="pa-2"
                                  cols="12"
                                  lg="4"
                                  md="6"
                                >
                                  <v-card
                                    class="rounded-lg"
                                    outlined
                                    @click="
                                      [
                                        (pIndex = index1),
                                        (productDetails = true),
                                      ]
                                    "
                                  >
                                    <v-list-item
                                      class="px-2 px-md-4"
                                      three-line
                                    >
                                      <v-list-item-avatar
                                        class="align-self-center rounded-lg me-2 me-md-2"
                                        size="64"
                                      >
                                        <v-img
                                          :src="
                                            product.gallery | getProductImage
                                          "
                                          contain
                                          width="64"
                                        />
                                        <!--                                  <v-icon v-else>mdi-account</v-icon>-->
                                      </v-list-item-avatar>

                                      <v-list-item-content>
                                        <v-list-item-title class="text-wrap">
                                          {{
                                            product.title ||
                                            product.name ||
                                            `${$t("product")} ${index1 + 1}`
                                          }}
                                        </v-list-item-title>
                                      </v-list-item-content>

                                      <v-list-item-action
                                        class="align-self-center ms-2 ms-md-4"
                                      >
                                        <div>
                                          <v-btn
                                            icon
                                            @click.stop="deleteProduct(index1)"
                                          >
                                            <v-icon>mdi-delete</v-icon>
                                          </v-btn>
                                        </div>

                                        <v-btn icon>
                                          <v-icon>mdi-chevron-left</v-icon>
                                        </v-btn>
                                      </v-list-item-action>
                                    </v-list-item>
                                  </v-card>
                                </v-col>
                              </template>
                            </v-row>
                          </v-tab-item>

                          <v-tab-item>
                            <v-card flat>
                              <v-card-title>{{
                                $t("edit_category")
                              }}</v-card-title>
                              <v-card-text>
                                <v-row no-gutters>
                                  <v-col class="px-6" cols="12" lg="4" md="6">
                                    <div class="rowinfo">
                                      <v-text-field
                                        v-model="category.name"
                                        append-icon="mdi-pencil"
                                        clear-icon="mdi-close-circle-outline"
                                        clearable
                                        dense
                                        class="contentinfo"
                                        hide-details
                                        :label="$t('categoryName')"
                                        outlined
                                      />
                                      <help-info
                                        :element-name="`${serviceName}-${componentName}-category-name`"
                                        :service-name="serviceName"
                                        :help-data="helpData"
                                        class="buttoninfo"
                                        :label="$t('categoryName')"
                                      />
                                    </div>
                                  </v-col>
                                  <v-col cols="12">
                                    <pic-selector
                                      :bracket="productImageSize"
                                      :edit-name="false"
                                      :field.sync="category.picture"
                                      one-pic
                                      single
                                    />
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                            <v-divider />
                            <v-card
                              v-if="
                                category.children && !!category.children.length
                              "
                              flat
                            >
                              <v-card-title>{{
                                $t("EditSubCategoty")
                              }}</v-card-title>
                              <v-card-text>
                                <v-row no-gutters>
                                  <v-col class="px-6" cols="12" lg="4" md="6">
                                    <div class="rowinfo">
                                      <v-text-field
                                        v-model="computedCategory.name"
                                        append-icon="mdi-pencil"
                                        clear-icon="mdi-close-circle-outline"
                                        clearable
                                        dense
                                        hide-details
                                        :label="$t('subCategoryName')"
                                        outlined
                                      />
                                      <help-info
                                        v-if="index === 0"
                                        :element-name="`${serviceName}-${componentName}-computedCategory-name`"
                                        :service-name="serviceName"
                                        :help-data="helpData"
                                        class="buttoninfo"
                                        :label="$t('subCategoryName')"
                                      />
                                    </div>
                                  </v-col>
                                  <v-col cols="12">
                                    <pic-selector
                                      :bracket="productImageSize"
                                      :edit-name="false"
                                      :field.sync="computedCategory.picture"
                                      one-pic
                                      single
                                    />
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                        </template>
                      </custom-tabs>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </div>

              <div v-else-if="productDetails" key="edit">
                <product-editor
                  ref="editor"
                  v-model="computedProduct"
                  :category="computedCategory"
                  :online-shop="value.onlineShop"
                  @close="[(productDetails = false), (pIndex = null)]"
                  @input="saveNewProduct"
                  @saved="editProduct"
                />
              </div>
            </transition>
          </v-card>
        </custom-popup>

        <v-card-actions class="px-2 pt-6">
          <div class="rowinfo" style="width: 100% !important">
            <v-btn
              color="success"
              outlined
              @click="showAddCat = true"
              class="contentinfo"
            >
              <v-icon>mdi-plus</v-icon>
              {{ $t("addCategory") }}
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-computedCategory-name`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('addCategory')"
            />
          </div>
        </v-card-actions>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import productManagement from "./productManagement.vue";
import ProductEditor from "@/view/components/Product/ProductEditor";
import PicSelector from "@/view/components/UploadCenter/picSelector";
import { mapGetters, mapState } from "vuex";
import CategoryPicker from "@/view/components/pickers/categoryPicker.vue";
import AddCustomCategory from "@/view/components/adapters/addCustomCategory.vue";
import ProductPicker from "@/view/components/pickers/productPicker.vue";
import StoreShopContent from "@/utilities/StoreShopContent";

const productWorker = new Worker("js/bulkAddDefaultProducts.js");

export default {
  name: "ProductGallery",

  components: {
    ProductPicker,
    AddCustomCategory,
    CategoryPicker,
    PicSelector,
    ProductEditor,
    productManagement,
  },

  props: {
    value: {
      require: true,
    },
  },

  inject: ["productImageSize"],

  data() {
    return {
      isDeletingAll: false, 
      helpData: [],
      serviceName: "Qrland",
      componentName: "productGallery-index",
      catTabs: 0,

      dialog: false,
      editedProduct: {},
      editGalleryName: -1,
      tabs: 0,
      subTabs: 0,
      tempContent: [],
      prototype: {
        title: "محصول",
        content: "",
        price: 0,
        discount: 0,
        payLink: "",
        details: [
          {
            link: "",
            icon: "",
            value: "",
          },
        ],
        gallery: [{ name: "", images: [] }],
        color: undefined,
        icon: undefined,
      },
      productDetails: false,
      pIndex: null,
      loading: false,
      showAddCat: false,
      showAddSubCat: false,
      pickProducts: false,
      saveProductsLoading: false,
    };
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.$root.$on("fetchCategories", this.getCategories);
  },

  mounted() {
    if (!this.isModelList) this.getCategories();
  },

  computed: {
    ...mapGetters("localstorage", ["createQrID"]),
    ...mapState("local", ["qr_id"]),
    tabItems() {
      return [
        { text: this.$t("products"), value: "products", icon: "sign-yield" },
        {
          text: this.$t("editCategory"),
          value: "edit-category",
          icon: "pencil",
        },
      ];
    },
    cons() {
      return {
        title: this.$t("add_edit_products"),
        buttons: [
          { type: "submit", handler: () => this.submitProducts(false) },
          { type: "close", handler: this.closeDialog },
        ],
      };
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$forceUpdate();
      },
    },
    computedCategory: {
      get() {
        return !!this.computedValue?.items?.[this.tabs]?.children?.length
          ? this.computedValue.items[this.tabs].children[this.subTabs]
          : this.computedValue?.items?.[this.tabs];
      },
      set(val) {
        if (!!this.computedValue?.items[this.tabs]?.children?.length)
          this.computedValue.items[this.tabs].children[this.subTabs] = val;
        else this.computedValue.items[this.tabs] = val;
      },
    },
    hasComputedCategory() {
      return (
        !!this.computedValue?.items?.[this.tabs]?.children?.length ||
        !!this.computedValue?.items?.[this.tabs]
      );
    },
    computedProduct: {
      get() {
        return this.computedCategory?.products[this.pIndex];
      },
      set(val) {
        try {
          this.computedCategory.products[this.pIndex] = val;
        } catch (e) {
          console.log(e);
        }
      },
    },
    computedCategoryPickerId() {
      return this.computedCategory?.hasOwnProperty("temp_id")
        ? this.computedCategory?.temp_id
        : this.computedCategory?.source_id;
    },
    isModelList() {
      let arr = ["qr.name.editBPage", "qr.bPage"];
      return (
        this.$route.name.toLowerCase().includes("model") ||
        arr.includes(this.$route.name)
      );
    },
  },

  methods: {
        async deleteAllCategories() {
      const confirmed = await this.$modal.yesNo(
        this.$t("confirmDeleteAllCategories") || "آیا از حذف تمامی دسته‌بندی‌ها اطمینان دارید؟",
      );

      if (confirmed) {
        this.isDeletingAll = true;

        this.$api
          .delete("/v1/testQr/category-menus/delete-by-qr-id", {
            params: {
              qr_id: this.createQrID ?? this.qr_id,
            },
          })
          .then(({ data }) => {
            this.computedValue.items = [];
            this.$toast.success(this.$t("allCategoriesDeleted") || "تمام دسته‌بندی‌ها با موفقیت حذف شدند.");
            this.$forceUpdate();
          })
          .catch(({ response }) => {
            console.error("Failed to delete all categories: ", response);
            this.$toast.error(this.$t("errorDeletingCategories") || "خطا در حذف دسته‌بندی‌ها.");
          })
          .finally(() => {
            this.isDeletingAll = false;
          });
      }
    },
    fetch() {
      // i dont need set or not? i need ask mr. mahvadi
      this.$forceUpdate();
    },
    getCategories(reFetch = true) {
      this.loading = true;

      this.$api
        .get("/v1/testQr/category-menus", {
          params: {
            qr_id: this.createQrID ?? this.qr_id,
          },
        })
        .then(({ data }) => {
          let d = [...data.data];
          d.forEach((item) => getSubs(item));
          this.computedValue.items = d;
          if (!!d?.length && reFetch) {
            // جلوگیری از ریست شدن به تب اول
            let activeTab = this.tabs < d.length ? this.tabs : d.length - 1;
            this.openDialog(activeTab >= 0 ? activeTab : 0);
          }          this.$forceUpdate();

          function getSubs(cat) {
            if (cat.products?.length) {
              cat.products.forEach((product) => {
                if (product.options instanceof Array)
                  product.options = fixOptions(product.options);
                if (product.gallery instanceof Array)
                  product.gallery = fixgalleries(product.gallery);
              });
            }

            if (cat.children?.length) {
              cat.children.forEach((item) => getSubs(item));
            }
          }
          function fixgalleries(gallery) {
            if (typeof gallery === "string" && gallery) {
              return [{ name: "", images: [gallery] }];
            }
            if (Array.isArray(gallery) && gallery.length > 0) {
              return gallery.map((item) => ({
                name: item.name || "",
                images: Array.isArray(item.images) ? item.images : [],
              }));
            }
            return [{ name: "", images: [] }];
          }
          function fixOptions(options) {
            const src = {
              inventory: "",
              max_order: "",
              price: 0,
              discount: "",
              id: null,
            };
            return options.reduce((obj, curr) => {
              let target = JSON.parse(JSON.stringify(src));

              for (const key in target) {
                if (curr.hasOwnProperty(key)) {
                  target[key] = curr[key];
                }
              }

              if (curr.type === "color")
                target = {
                  ...target,
                  color: curr.value,
                  color_name: curr.name,
                };
              else
                target = {
                  ...target,
                  size: curr.value,
                };

              if (obj[curr.type]) obj[curr.type].push(target);
              else obj[curr.type] = [target];

              return obj;
            }, {});
          }
        })
        .finally(() => (this.loading = false));
    },
    openDialog(index) {
      this.tempContent = JSON.parse(JSON.stringify(this.computedValue.items));
      this.tabs = index;
      this.dialog = true;
    },
    addProduct() {
      // this.defPay = category.products[0]?.product.payLink
      this.pIndex = null;
      this.productDetails = true;
    },
    async deleteProduct(index, force = false) {
      const res =
        force ||
        (await this.$modal.yesNo(
          this.$t("deleted_product"),
          this.$t("confirm_delete_product"),
        ));

      if (res) {
        let product = this.computedCategory.products[index];

        if (!!Object.hasOwn(product, "id")) {
          this.loading = true;

          this.$api
            .delete("/v1/testQr/product", {
              params: {
                id: product.id,
              },
            })
            .then(({ data }) => {
              this.$toast.success(this.$t("productDeleted"));
              this.computedCategory.products.splice(index, 1);
              this.productDetails = false;
            })
            .catch(({ response }) =>
              console.log("failed to delete product: ", response),
            )
            .finally(() => (this.loading = false));
        } else {
          this.computedCategory.products.splice(index, 1);
          this.productDetails = false;
        }
      }
    },
    saveProducts(list) {
      this.$toast.info(this.$t("please_wait_store_product"), {
        timeout: 5000,
      });

      this.saveProductsLoading = true;
      const ssc = new StoreShopContent(this.createQrID ?? this.qr_id);

      let obj = {
        category_id: this.computedCategory.id,
        ids: [...list],
      };

      ssc
        .storeProductsByTemplateIds(obj)
        .then((data) => {
          this.$toast.success(this.$t("saved_product_success"));
          this.getCategories();
        })
        .catch((err) => {
          this.$toast.clear();
          this.$toast.error(this.$t("error_in_store"));
        })
        .finally(() => (this.saveProductsLoading = false));
    },
    saveNewProduct(obj) {
      if (!this.computedCategory.ids_list) this.computedCategory.ids_list = [];

      if (this.pIndex != null)
        this.computedCategory.ids_list[this.pIndex] = obj;
      else this.computedCategory.ids_list.push(obj);

      this.pIndex = null;
      this.productDetails = false;
    },
    addBulkProduct(list) {
      this.computedCategory.ids_list = [
        ...(this.computedCategory.ids_list || []),
        ...list,
      ];
    },
    editProduct(obj) {
      if (!this.computedCategory.products) this.computedCategory.products = [];

      if (this.pIndex != null)
        this.computedCategory.products[this.pIndex] = obj;
      else this.computedCategory.products.push(obj);

      this.pIndex = null;
      this.productDetails = false;
    },
    saveBulkProduct(list) {
      productWorker.postMessage(list);

      productWorker.onmessage = function (e) {
        if (!this.computedCategory.products)
          this.computedCategory.products = e.data;
        else this.computedCategory.products.push(...e.data);
      }.bind(this);

      productWorker.onerror = function (error) {
        console.error("Worker error:", error);
      };

      this.pIndex = null;
      this.productDetails = false;
    },
    submitProducts(reFetch = true) {
      this.loading = true;

      try {
        if (this.isModelList) {
          this.loading = false;
          this.dialog = false;
        } else {
          const ssc = new StoreShopContent(this.createQrID ?? this.qr_id);

          ssc
            .storeCategories(this.computedValue.items)
            .then((data) => {
              this.$toast.success(this.$t("successMessages.categorySaved"));

              ssc
                .storeProducts(data.data, this.computedValue.items)
                .then((data) => {
                  this.$toast.success(this.$t("successMessages.productSaved"));
                })
                .catch((err) => {
                  this.$toast.error(this.$t("errorMessages.saveProductFailed"));
                });
            })
            .catch((err) => {
              this.$toast.error(this.$t("errorMessages.categorySaved"));
            })
            .finally(() => {
              this.loading = false;
              this.productDetails = false;
              this.pIndex = null;
              this.dialog = false;
              this.getCategories(reFetch);
            });
        }
      } catch (e) {
        console.log(e);
      }
    },
    closeDialog() {
      this.computedValue.items = this.tempContent;
      this.dialog = false;
      this.$nextTick(() => {
        this.tempContent = [];
      });
    },
    async deleteCat(index) {
      if (await this.$modal.yesNo(this.$t("deleteCategory"))) {
        let cat = this.computedValue.items[index];

        if (!!Object.hasOwn(cat, "id")) {
          this.loading = true;

          this.$api
            .delete("/v1/testQr/category-menus", {
              params: {
                id: cat.id,
              },
            })
            .then(({ data }) => {
              this.computedValue.items.splice(index, 1);
            })
            .finally(() => (this.loading = false));
        } else this.computedValue.items.splice(index, 1);
      }
    },
    moveUp(index) {
      let items = this.computedValue.items;
      this.computedValue.items = [];

      this.$nextTick(() => {
        let previousIndex = index - 1;
        let tempPreviousImage = { ...items[previousIndex] };
        let tempCurrentImage = { ...items[index] };

        items[index] = tempPreviousImage;
        items[previousIndex] = tempCurrentImage;

        this.$forceUpdate();
        this.computedValue.items = items;
      });
    },
    moveDown(index) {
      let items = this.computedValue.items;
      this.computedValue.items = [];

      this.$nextTick(() => {
        let nextIndex = index + 1;
        let tempPreviousImage = { ...items[nextIndex] };
        let tempCurrentImage = { ...items[index] };

        items[index] = tempPreviousImage;
        items[nextIndex] = tempCurrentImage;

        this.$forceUpdate();
        this.computedValue.items = items;
      });
    },
    copyCat(category, index) {
      let name = category?.name?.trimEnd().replace(/(\d+)$/g, "") || "";

      const lastIndex = this.computedCategory.filter(
        (item) => item.name.indexOf(name) >= 0,
      );

      this.computedCategory.splice(index + 1, 0, {
        ...category,
        name: name + !!lastIndex ? name + lastIndex.length : name,
      });
    },
    copyProduct(product, index, field) {
      let name = product.title.trimEnd().replace(/(\d+)$/g, "");

      const lastIndex = field.filter((item) => item.title.indexOf(name) >= 0);

      this.computedCategory.products.splice(index + 1, 0, {
        ...product,
        title: name + !!lastIndex ? name + lastIndex.length : name,
      });
    },
    submitNewCategories(e, sub = false) {
       if (sub) {
        this.computedValue.items[this.tabs].children.push(e);
        // فوکوس روی زیرگروه جدید
        this.subTabs = this.computedValue.items[this.tabs].children.length - 1;
      } else {
        this.computedValue.items = this.computedValue.items.concat(e);
        // فوکوس روی گروه اصلی جدید
        this.tabs = this.computedValue.items.length - 1;
      }

      this.submitProducts();
    },
    async deleteSubCat(index) {
      let subCat = this.computedValue.items[this.tabs].children[index];
      if (
        await this.$modal.yesNo(
          `${this.$t("delete_category")} ${subCat.name || subCat.title} ؟`,
        )
      ) {
        if (!!Object.hasOwn(subCat, "id")) {
          this.loading = true;

          this.$api
            .delete("/v1/testQr/category-menus", {
              params: {
                id: subCat.id,
              },
            })
            .then(({ data }) => {
              this.$toast.success(this.$t("confirm_delete_category"));
              this.computedValue.items[this.tabs].children.splice(index, 1);
            })
            .catch(({ response }) => {
              this.$toast.error(this.$t("error_delete_category"));
            })
            .finally(() => (this.loading = false));
        } else this.computedValue.items[this.tabs].children.splice(index, 1);
      }
    },
    closeClicked(index) {
      this.computedCategory.ids_list.splice(index, 1);
      this.$forceUpdate();
    },
  },

  beforeDestroy() {
    this.$root.$off("fetchCategories", this.fetchCategories);
  },
};
</script>

<style scoped>
.dialog-content >>> .v-tabs .v-tabs-slider-wrapper {
  display: block !important;
}

@media screen and (max-width: 600px) {
  .v-tabs >>> .v-slide-group__prev,
  .v-tabs >>> .v-slide-group__next {
    display: none !important;
  }
}
</style>
